import React from 'react';
import cls from './ModalBody.module.css';
import classNames from 'classnames';

export const ModalBody = ({ width = '100%', children, classes }) => {
    return (
        <div style={{ width: width }} className={classNames(cls.customModalBody, [classes])}>
            {children}
        </div>
    );
};
